import { gql } from '@apollo/client'

export const CHANGE_LOYALTY_CAMPAIGN_RULE = gql`
  mutation ChangeLoyaltyCampaignRule($rule: ChangeLoyaltyCampaignRuleRuleInput!, $id: ID!) {
    changeLoyaltyCampaignRule(input: { id: $id, rule: $rule })
  }
`

export const ADD_LOYALTY_CAMPAIGN_RULE_CITY_SEGMENTS = gql`
  mutation addLoyaltyCampaignRuleConditionsCitySegments(
    $id: ID!
    $rule: AddLoyaltyCampaignRuleConditionsCitySegmentsRuleInput!
  ) {
    addLoyaltyCampaignRuleConditionsCitySegments(input: { id: $id, rule: $rule })
  }
`

export const ADD_LOYALTY_CAMPAIGN_RULE_SALES_CHANNELS = gql`
  mutation addLoyaltyCampaignRuleConditionsSalesChannels(
    $id: ID!
    $rule: AddLoyaltyCampaignRuleConditionsSalesChannelsRuleInput!
  ) {
    addLoyaltyCampaignRuleConditionsSalesChannels(input: { id: $id, rule: $rule })
  }
`

export const ADD_LOYALTY_CAMPAIGN_RULE_ROUTE_SERVICES = gql`
  mutation addLoyaltyCampaignRuleConditionsRouteServices(
    $id: UUID!
    $rule: AddLoyaltyCampaignRuleConditionsRouteServicesRuleInput!
  ) {
    addLoyaltyCampaignRuleConditionsRouteServices(input: { id: $id, rule: $rule })
  }
`

export const CREATE_LOYALTY_CAMPAIGN_RULE = gql`
  mutation CreateLoyaltyCampaignRule(
    $ruleHowToGetIt: String!
    $ruleName: String!
    $ruleValidAt: String!
    $ruleDescription: String
    $ruleDetails: String!
    $ruleConditions: CreateLoyaltyCampaignRuleConditionsInput!
    $ruleEffects: CreateLoyaltyCampaignRuleEffectsInput!
    $campaignId: ID!
  ) {
    createLoyaltyCampaignRule(
      input: {
        howToGet: $ruleHowToGetIt
        name: $ruleName
        validAt: $ruleValidAt
        description: $ruleDescription
        details: $ruleDetails
        conditions: $ruleConditions
        effects: $ruleEffects
        id: $campaignId
      }
    )
  }
`
